import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { IECI } from "../../models/ECI";
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useEffect, useState } from "react";
import { Fetch } from "../../shared/Fetch";
import { JVInput } from "../../shared/JVInput";
import { EmptyECI } from "./EmptyECI";
import { JVInputCheck } from "../../shared/JVInputCheck";
import { IRequirementMast, Job_Type, Req_Term } from "../../models/RequirementMast";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { IConsultant_ECI } from "../../models/Consultant_ECI";
import { JVDate } from "../../shared/JVDate";
import { JVDropdown } from "../../shared/JVDropdown";
import { ECIType } from "../../models/FDropdown";
import { IECIStatusDropdown, ITimeZoneDropdown } from "../../models/IDropdown";
import { JVTime } from "../../shared/JVTime";
import { RadioButton } from "primereact/radiobutton";
import { format } from 'date-fns';
import { ISignatureMast } from "../../models/SignatureMast";
import { IEmailTemplate } from "../../models/EmailTemplate";
import { JVSunEditor } from "../../shared/JVSuneditor";
import { Steps } from 'primereact/steps';

const items = [
    {
        label: ' '
    },
    {
        label: ' '
    },
];

const schema = yup.object({
    req_ID: yup.number().nullable(),
    submission_ID: yup.number().required("Select Candidate").min(1, "Select Candidate"),
    ecI_Date: yup.date().required("Date is required").typeError("Date is required"),
    ecI_Time: yup.date().required("Time is required").typeError("Time is required"),
    ecI_Time_Zone: yup.number().min(1, "Zone is required").required("Zone is required"),
    ecI_Type: yup.string().required("ECI Type is required"),
    ecI_Client: yup.string().nullable(),
    ecI_InterviewrName: yup.string().nullable(),
    ecI_Feedback_Status: yup.number().min(1, "Status is required").required("Status is required"),
    comments: yup.string().when('ecI_Feedback_Status', val => {
        return (val === 11 || val === 3 || val === 9 || val === 8 || val === 16) ?
            yup.string().required("Comment is required").typeError("Comment is required") :
            yup.string().nullable();
    }),
    email_Subject: yup.string(),
    rejectedByECIReasonStatus: yup.string().when('ecI_Feedback_Status', val => {
        return (val === 9) ?
            yup.string().required("status is required") :
            yup.string().nullable()
    }),
});

interface Iprops {
    singleData: IConsultant_ECI,
    tableData: IECI | undefined,
    open: boolean,
    hideDialog: () => void,
    toast: any,
    reload: boolean,
    setReload: (is: boolean) => void,
    ShowCelebration: (type: string) => void
}

export const Form = (props: Iprops) => {
    const [loading, setLoading] = useState(false);
    const [req, setReq] = useState<IRequirementMast>();
    const [submittals, setSubmittals] = useState<IECI[]>([]);
    const [timeZome, setTimeZone] = useState<ITimeZoneDropdown[]>();
    const [ecIStatus, setEciStatus] = useState<IECIStatusDropdown[]>([]);
    const [ecIStatusDd, setEciStatusDd] = useState<IECIStatusDropdown[]>();
    const [signature, setSignature] = useState("");
    const [signatureDisable, setSignatureDisable] = useState(true);
    const [mailBody, setMailBody] = useState("");
    const [shwEmailSubject, setShwEmailSubject] = useState(false);
    const [activeIndex, setActiveIndex] = useState(0);
    const [loadEmail, setLoadEmail] = useState(true);
    const [shwRejectedByECIReasonStatus, setShwRejectedByECIReasonStatus] = useState<boolean>(false);
    const [rejectedByPVReasondDropDownRows, setRejectedByPVReasondDropDownRows] = useState([]);



    const { control, handleSubmit, formState: { errors }, watch, reset, setValue } = useForm<IConsultant_ECI & { rejectedByECIReasonStatus?: number }>({
        resolver: yupResolver(schema),
        shouldFocusError: false,
        defaultValues: props.singleData
    });

    useEffect(() => {
        if (props.singleData.ecI_ID) {
            getEci();
            const data = [...ecIStatus];
            const dataDd = data.filter(d => d.ecI_Type_ID !== 1);
            setEciStatusDd(dataDd);
        }
        else {
            const data = [...ecIStatus];
            const dataDd = data.filter(d => d.ecI_Type_ID === 1);
            setEciStatusDd(dataDd);
        }
        if (props.tableData?.req_ID) loadRequirement(props.tableData.req_ID);
        if (props.singleData?.ecI_Feedback_Status === 7) setShwEmailSubject(true);
    }, [props.singleData]);

    useEffect(() => {
        const subscription = watch((value, { name, type }) => {
            if (name === "ecI_Feedback_Status") {
                if (value.ecI_Feedback_Status === 7) {
                    setShwEmailSubject(true);
                    setShwRejectedByECIReasonStatus(s => s = false);
                } else if (value.ecI_Feedback_Status === 9) {
                    setShwRejectedByECIReasonStatus(s => s = true);
                    LoadSubRejectionCategory("Rejected");
                } else {
                    setShwEmailSubject(false);
                    setShwRejectedByECIReasonStatus(s => s = false);
                }
            }
        });

        return () => subscription.unsubscribe();
    }, [watch]);

    const loadRequirement = async (req_ID: number) => {
        const response = await Fetch("Requirement_MAST/byId", "GET", null, `req_id=${req_ID}`, props.toast);
        if (response) {
            const data: IRequirementMast = await response.json();
            setReq(data);
        }
    };

    useEffect(() => {
        loadStatus();
        loadTimeZone();
        loadSignature();
    }, []);

    const generateMail = async () => {
        if (!errors.ecI_Date && !errors.ecI_Time && !errors.ecI_Time_Zone && !errors.ecI_Feedback_Status && req !== undefined) {
            const _timeZone = timeZome?.find(tz => tz.timezone_ID === control._formValues.ecI_Time_Zone);
            const _eciStatus = ecIStatus?.find(s => s.ecI_Type_ID === control._formValues.ecI_Feedback_Status);

            setLoadEmail(false);

            const response = await Fetch("Email_Template/byName", "GET", null, `name=${"ECI-" + _eciStatus?.ecI_Type_Name}`, props.toast);
            if (response) {
                const data: IEmailTemplate = await response.json();
                if (data.template_Subject) {
                    setValue("email_Subject", data.template_Subject);
                    control._formValues.email_Subject = data.template_Subject;
                }
                let table = '';
                if (control._formValues.ecI_Feedback_Status === 7) {
                    table = `<table>
            <thead>
                <th bgcolor="#f2f2f2">Job Title</th>
                <th bgcolor="#f2f2f2">Job Type</th>
                <th bgcolor="#f2f2f2">Job Term</th>
                <th bgcolor="#f2f2f2">Location</th>
                <th bgcolor="#f2f2f2">Duration</th>
                <th bgcolor="#f2f2f2">End Client</th>
                <th bgcolor="#f2f2f2">ECI Date</th>
                <th bgcolor="#f2f2f2">Time & Zone</th>
                <th bgcolor="#f2f2f2">Status</th>
            </thead>
            <tbody>
                <td bgcolor="#ebebeb">${req.req_Job_Title}</td>
                <td bgcolor="#ebebeb">${req.job_Type ? Job_Type[req.job_Type] : ''}</td>
                <td bgcolor="#ebebeb">${req.req_Term ? Req_Term[req.req_Term] : ''}</td>
                <td bgcolor="#ebebeb">${req.city_Name}, ${req.state_Name}</td>
                <td bgcolor="#ebebeb">${req.req_Duration}</td>
                <td bgcolor="#ebebeb">${req.req_EndClient}</td>
                <td bgcolor="#ebebeb">${format(new Date(control._formValues.ecI_Date), 'dd/MM/yyyy').toUpperCase()}</td>
                <td bgcolor="#ebebeb">${format(new Date(control._formValues.ecI_Time), 'hh:mm a').toUpperCase()} ${_timeZone?.time_Zone_Name}</td>
                <td bgcolor="#ebebeb">${_eciStatus?.ecI_Type_Name}</td>
            </tbody>
        </table>
        <p><b>Job Description -</b> \n${req.req_JobDescription}</p>`;
                } else {

                    table = `<table>
            <thead>
                <th bgcolor="#f2f2f2">RequirementID</th>
                <th bgcolor="#f2f2f2">Job Title</th>
                <th bgcolor="#f2f2f2">Job Type</th>
                <th bgcolor="#f2f2f2">Job Term</th>
                <th bgcolor="#f2f2f2">Location</th>
                <th bgcolor="#f2f2f2">Duration</th>
                <th bgcolor="#f2f2f2">End Client</th>
                <th bgcolor="#f2f2f2">ECI Date</th>
                <th bgcolor="#f2f2f2">Time & Zone</th>
                <th bgcolor="#f2f2f2">Status</th>
            </thead>
            <tbody>
                <td bgcolor="#ebebeb">${req.req_ID}</td>
                <td bgcolor="#ebebeb">${req.req_Job_Title}</td>
                <td bgcolor="#ebebeb">${Job_Type[req.job_Type || 0]}</td>
                <td bgcolor="#ebebeb">${Req_Term[req.req_Term || 0]}</td>
                <td bgcolor="#ebebeb">${req.city_Name}, ${req.state_Name}</td>
                <td bgcolor="#ebebeb">${req.req_Duration}</td>
                <td bgcolor="#ebebeb">${req.req_EndClient}</td>
                <td bgcolor="#ebebeb">${format(new Date(control._formValues.ecI_Date), 'dd/MM/yyyy').toUpperCase()}</td>
                <td bgcolor="#ebebeb">${format(new Date(control._formValues.ecI_Time), 'hh:mm a').toUpperCase()} ${_timeZone?.time_Zone_Name}</td>
                <td bgcolor="#ebebeb">${_eciStatus?.ecI_Type_Name}</td>
            </tbody>
        </table>
        <br/>
        ${(control._formValues.comments?.trim().length > 0) ? `<p><b>Comment : - </b> ${control._formValues.comments}</p>` : ''}
        <br/>
        <p><b>Job Description -</b> \n${req.req_JobDescription}</p>`;
                }


                data.template_Body = data.template_Body ? data.template_Body.replace("@salesUserName", (props.tableData?.salesmanager && props.tableData?.salesActiveStatus === false) ? (props.tableData?.salesmanager || "").split("-")[0] : "") : "";
                data.template_Body = data.template_Body.replace("@salesBranchName", (props.tableData?.salesBranchName && props.tableData?.salesActiveStatus === false) ? props.tableData?.salesBranchName : (props.tableData?.salesCompanyName || ""));
                data.template_Body = data.template_Body.replace("@recruiterName", (props.tableData?.user_Name && props.tableData?.recruitersActiveStatus === false) ? (props.tableData?.user_Name || "").split("-")[0] : "");
                data.template_Body = data.template_Body.replace("@recruiterBranchName", (props.tableData?.recruiterBranchName && props.tableData?.recruitersActiveStatus === false) ? props.tableData?.recruiterBranchName : (props.tableData?.recruiterCompanyName || ""));
                //data.template_Body = data.template_Body.replace("@consultantName", props.tableData?.consultant_Name ? props.tableData?.consultant_Name : "");
                setMailBody(data.template_Body + table);
                setLoadEmail(true);
            }
        } else props.toast.current.show({ severity: 'error', detail: "first fill all the above required details.", life: 3000 });
    };

    const loadStatus = async () => {
        const response = await Fetch("Dropdown/ecI_status", "GET", null, null, null);
        if (response) {
            const data: Array<IECIStatusDropdown> = await response.json();
            setEciStatus(data);
            if (props.singleData.ecI_ID) setEciStatusDd(data);
            else {
                const dataDd = data.filter(d => d.ecI_Type_ID === 1);
                setEciStatusDd(dataDd);
            }
        }
    };


    const loadTimeZone = async () => {
        const response = await Fetch("Dropdown/timezone", "GET", null, null, null);
        if (response) {
            const data: Array<ITimeZoneDropdown> = await response.json();
            setTimeZone(data);
        }
    }

    const loadSignature = async () => {
        const response = await Fetch("Signature_Mast", "GET", null, null, props.toast);
        if (response) {
            const data: ISignatureMast = await response.json();
            if (data.signature) setSignature(data.signature);
        }
    }

    const saveToDB = async (body: IConsultant_ECI) => {
        setLoading(true);

        if (body.email_Subject === "" || null) {
            props.toast.current.show({ severity: 'error', detail: "Email Subject is required", life: 3000 });
            setLoading(false);
        } else {
            const method = props.singleData?.ecI_ID ? "PUT" : "POST";
            const message = props.singleData?.ecI_ID ? "Updated Successfully" : "Added Successfully";

            const response = await Fetch("ECI", method, body, null, props.toast);

            if (response) {
                const data = await response.json();
                console.log(data);
                if (data.SalesTargetCompleted === true) {
                    if (data.error) {
                        props.toast.current.show({ severity: 'error', detail: data.error, life: 3000 });
                    }
                    props.ShowCelebration(data.type);
                }
                props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
                onHide();
                props.setReload(!props.reload);
                setLoading(false);
            } else setLoading(false);
        }
    }

    const onHide = () => {
        setShwRejectedByECIReasonStatus(s => s = false);
        setRejectedByPVReasondDropDownRows([]);
        props.hideDialog();
        reset(EmptyECI);
        setSubmittals([]);
        setReq(undefined);
        setMailBody("");
        setSignature(signature);
        setActiveIndex(0);
    }

    const idSchema = yup.object().shape({
        id: yup.number().required().min(1)
    });

    const getEci = async () => {
        const response = await Fetch("ECI/byId", "GET", null, `ecI_ID=${props.singleData.ecI_ID}`, props.toast);
        if (response) {
            const data: IConsultant_ECI = await response.json();
            if (data.ecI_Date) data.ecI_Date = new Date(data.ecI_Date);
            if (typeof (data.ecI_Time) === "string") {
                let timeArray = data.ecI_Time.split(" ");
                let hour = parseInt(timeArray[0].split(":")[0]);
                if (timeArray[1] === "PM") hour += 12;
                let minute = parseInt(timeArray[0].split(":")[1]);
                data.ecI_Time = new Date(0, 0, 0, hour, minute, 0);
            }
            data.comments = null;
            reset(data);
            if (data.ecI_Feedback_Status === 7) setShwEmailSubject(true);
        }
    }

    const searchReq = async () => {
        const valid = await idSchema.isValid({
            id: control._formValues.req_ID,
        });
        if (valid) {
            const id = control._formValues.req_ID;
            const response = await Fetch("Requirement_MAST/byId", "GET", null, `req_id=${id}`, props.toast);
            const response2 = await Fetch("ECI/submital", "GET", null, `req_id=${id}`, props.toast);
            if (response && response2) {

                const data: IRequirementMast = await response.json();
                setValue("ecI_Client", data.req_EndClient);
                setReq(data);

                const data2: IECI[] = await response2.json();
                setSubmittals(data2);
                if (data2.length === 1) {
                    setValue("submission_ID", data2[0].submission_id);
                } else {
                    setValue("submission_ID", null);
                }
            } else { setValue("submission_ID", null); setSubmittals([]); }
        }
        else props.toast.current.show({ severity: 'error', content: "Please Enter a Valid Req ID" });
    }

    function onSubmit(data: IConsultant_ECI & { rejectedByECIReasonStatus?: number }) {
        if (data.ecI_Time !== null && data.ecI_Time !== undefined) data.ecI_Time = format(new Date(data.ecI_Time), 'hh:mm a').toUpperCase();
        if (data?.ecI_Date instanceof Date) {
            const localDob = new Date(data.ecI_Date.getTime() - data.ecI_Date.getTimezoneOffset() * 60000);
            (data.ecI_Date as any) = localDob.toISOString();
        }
        if (mailBody.length < 1) props.toast.current.show({ severity: 'error', content: "Email Body is Required." });
        else {
            data.email_Body = mailBody;
            data.email_signature = signature;
            if (data.ecI_Feedback_Status === 9 && (data.rejectedByECIReasonStatus === null || data.rejectedByECIReasonStatus === 0)) {
                props.toast.current.show({ severity: 'error', detail: "Select rejection reason status", life: 3000 });
            } else saveToDB(data);
        }
    }

    const submission_id = (rowData: IECI) => {
        return (
            <Controller name='submission_ID' control={control} render={({ field }) => (
                <RadioButton {...field} checked={rowData.submission_id === control._formValues.submission_ID} value={rowData.submission_id} />
            )} />
        );
    };

    const OnNext = () => {
        if (control._formValues.ecI_Date !== null && control._formValues.ecI_Time !== null && (control._formValues.ecI_Time_Zone !== 0 && control._formValues.ecI_Time_Zone !== null) && (control._formValues.ecI_Feedback_Status !== 0 && control._formValues.ecI_Feedback_Status !== null)) {
            if (control._formValues.ecI_Feedback_Status === 11 || control._formValues.ecI_Feedback_Status === 3 || control._formValues.ecI_Feedback_Status === 9 || control._formValues.ecI_Feedback_Status === 8 || control._formValues.ecI_Feedback_Status === 16) {
                if (control._formValues.comments != null && control._formValues.comments != "") {
                    setActiveIndex(1);
                    generateMail();
                }
            } else {
                setActiveIndex(1);
                generateMail();
            }
        }
    }

    // const RejectedByECIReasondDropDownRows = [
    //     { name: '-- SELECT --', value: 0 },
    //     { name: 'Testing 1', value: 1 },
    //     { name: 'Testing 2', value: 2 },
    //     { name: 'Testing 3', value: 3 },
    //     { name: 'Testing 4', value: 4 },
    //     { name: 'Testing 5', value: 5 },
    // ];

    async function LoadSubRejectionCategory(name: string) {
        const response = await Fetch("Pipeline_Status_Mast/getSubCategoryListing", "GET", null, `ssn=${name}`, props.toast);
        if (response) {
            const data = await response.json();
            setRejectedByPVReasondDropDownRows(data);
        }
    };

    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header="Add/Edit ECI" modal className="p-fluid" onHide={onHide}>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">

                {!props.singleData.ecI_ID ? <><JVInputCheck column={3} placeholder="Requirement ID" control={control} name="req_ID" func={searchReq} />
                    {submittals.length > 0 &&
                        <div className="field col-12 md:col-12">
                            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                                header={`List Of Submissions found against ${req?.req_ID} (${req?.req_Job_Title})`}
                                size="small"
                                value={submittals}
                            >
                                <Column field="submission_id" header="Select" body={submission_id} />
                                <Column field="consultant_Name" header="Consultant Name" />
                                <Column field="user_Name" header="Recruiter" />
                                <Column field="submitalDate" header="Date" />
                                <Column field="buying_Rate" header="Rate" />
                                <Column field="end_Client" header="End Client" body={() => req !== undefined ? `${req.req_EndClient}` : ''} />
                                <Column field="location" header="Location" body={() => req !== undefined ? `${req.city_Name},${req.state_Name}` : ''} />
                            </DataTable></div>
                    }</> :
                    <DataTable className="m-4" style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                        size="small"
                        value={[props.tableData]}
                    >
                        <Column field="req_ID" header="Req.ID" />
                        <Column field="salesmanager" header="Sales Manager" body={(rowData) => { const value = rowData.salesmanager; if (!value) return ""; return value.split("-")[0]; }} />
                        <Column field="user_Name" header="Recruiter" body={(rowData) => { const value = rowData.user_Name; if (!value) return ""; return value.split("-")[0]; }} />
                        <Column field="consultant_Name" header="Consultant Name" />
                        <Column field="req_Job_Title" header="Job Title" />
                        <Column field="thirdparty" header="Third Party" />
                        <Column field="vendor_Company_Name" header="Prime Vendor" />
                        <Column field="ecI_Client" header="End Client" />
                        <Column field="location" header="Location" body={() => req !== undefined ? `${req.city_Name},${req.state_Name}` : ''} />
                    </DataTable>}
                <div style={{ margin: '10px 0', width: '100%' }}></div>
                <Steps className="w-full" model={items} activeIndex={activeIndex} readOnly={false} />
                <div style={{ margin: '10px 0', width: '100%' }}></div>
                {activeIndex === 0 && <>
                    <JVDate column={3} label="Date" required control={control} name="ecI_Date" error={errors.ecI_Date?.message} />
                    <JVTime column={3} label="Time" required control={control} name="ecI_Time" error={errors.ecI_Time?.message} />

                    <JVDropdown column={3} label="Zone" required control={control} name="ecI_Time_Zone" optionLabel="time_Zone_Name"
                        optionValue="timezone_ID" options={timeZome} placeholder="Select Time Zone" error={errors.ecI_Time_Zone?.message} />

                    {!props.singleData.ecI_ID && <JVDropdown column={3} label="Type" required control={control} name="ecI_Type" optionLabel="name" optionValue="name"
                        options={ECIType} placeholder="Select ECI Type" error={errors.ecI_Type?.message} />}

                    {!props.singleData.ecI_ID && <JVInput column={3} label="Client" control={control} name="ecI_Client" />}
                    {!props.singleData.ecI_ID && <JVInput column={3} label="Interviewer Name" control={control} name="ecI_InterviewrName" error={errors.ecI_InterviewrName?.message} />}

                    <JVDropdown column={3} label="Status" required control={control} name="ecI_Feedback_Status" optionLabel="ecI_Type_Name"
                        optionValue="ecI_Type_ID" options={ecIStatusDd} placeholder="Select Status" error={errors.ecI_Feedback_Status?.message} />
                    <JVInput column={3} label="Comments" control={control} name="comments" error={errors.comments?.message} />
                    {shwRejectedByECIReasonStatus && <JVDropdown label="Reason Status" required={shwRejectedByECIReasonStatus} column={3} control={control} name="rejectedByECIReasonStatus" options={rejectedByPVReasondDropDownRows} optionLabel="sub_Status_Name" optionValue="sub_Status_Name" placeholder="Select Rejection Reason" error={errors.rejectedByECIReasonStatus?.message} />}

                    <div className="field col-12 md:col-12">
                        {activeIndex < 1 && <Button className="field col-12 md:col-6" onClick={() => shwRejectedByECIReasonStatus ? (control._formValues.rejectedByECIReasonStatus ? OnNext() : '') : OnNext()} label='NEXT'></Button>}
                        <Button className="className=field col-12 md:col-6 p-button-outlined" label="CLOSE" onClick={onHide} type="button"></Button>
                    </div>
                </>
                }

                {activeIndex === 1 && loadEmail && <>
                    <JVInput column={1} label="Email Subject" control={control} name="email_Subject" error={errors.email_Subject?.message} disabled={shwEmailSubject} />
                    <div className="col-12 md:col-12 md:col-12">
                        <div style={{ display: 'flex', justifyContent: "space-between", alignItems: "flex-end" }}>
                            <label>Email Body</label>
                            <div className="m-1">
                                {/* <Button label="Fill Email Body" type="button" icon="pi pi-envelope" className="p-button p-button-danger" onClick={generateMail} /> */}
                            </div>
                        </div>
                        <JVSunEditor value={mailBody} handleChange={setMailBody} />
                    </div>

                    <div className="col-12 md:col-12 md:col-12">
                        <div style={{ display: 'flex', justifyContent: "space-between", alignItems: "flex-end" }}>
                            <label>Signature</label>
                            <div className="m-1">
                                <Button type="button" icon="pi pi-pencil" className="p-button-rounded p-button-text" onClick={() => setSignatureDisable(!signatureDisable)} />
                            </div>
                        </div>
                        <JVSunEditor value={signature} handleChange={setSignature} disable={signatureDisable} />
                    </div>

                    <div style={{ margin: '10px 0', width: '100%' }}></div>
                    <div className="field col-12 md:col-12">
                        {activeIndex > 0 && <Button className="className=field col-12 md:col-6 p-button-outlined" onClick={() => setActiveIndex(activeIndex - 1)} label='PREVIOUS'></Button>}
                        <Button className="field col-12 md:col-6 mt-3" loading={loading} label="SAVE" type="submit"></Button>
                        <Button className="className=field col-12 md:col-6 p-button-outlined" label="CLOSE" onClick={onHide} type="button"></Button>
                    </div>
                </>
                }

            </form>
        </Dialog>
    );
}
